import { makeStyles } from "tss-react/mui"


export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'grid',
            gridArea: 'main-content',
            height: 'max-content',
            minHeight: '100%',
            maxHeight: '100%',
            gridTemplateRows: 'auto auto minmax(0, 1fr)',
            gridTemplateColumns: 'minmax(0px, 1fr)',
            gridTemplateAreas: '"header" "infobar" "content"',
            rowGap: '2px'
        },
        simulatorTimeControls: {
            borderBottomLeftRadius: '0px',
            borderBottomRightRadius: '0px'
        },
        infoBar: {
            gridArea: 'infobar',
            borderRadius: '0px',
            height: '44px'
        },
        contentContianer: {
            gridArea: 'content'
        },
        optionChainContainer: {
            height: '100%',
        },
        payoffGraphContainer: {
            height: '100%'
        },
        customTabPanel: {
            display: 'grid',
            gridTemplateRows: 'minmax(0, 1fr) max-content',
            gridTemplateColumns: 'minmax(0px, 1fr)'
        }
    }
})